/* USgovmint — xử lý chung cho trang danh mục (ug-collection) và trang tìm kiếm (ug-search).
   Mỗi khối có <div class="ug-cl" id="ug-cl-<section id>" data-sid="<section id>">.
   - Link lọc / bỏ lọc / Clear all (a[data-ug-nav]), form giá + sắp xếp (form[data-ug-form]) → tải lại riêng khối
     bằng Section Rendering API, cập nhật địa chỉ (pushState), nút Back của trình duyệt chạy đúng (popstate).
   - "Load More" (a[data-more]) → nối thêm sản phẩm trang sau vào lưới.
   - Ngăn "All Filters" (<dialog>): mở/đóng, khoá cuộn, bấm nền để đóng; chọn lọc trong ngăn thì ngăn vẫn mở.
   - Ô lọc nhanh (<details data-dd>): chỉ mở 1 cái, bấm ra ngoài / Esc để đóng.
   Không JS: mọi thứ vẫn là link/form thường. */
(function () {
  var pw = document.querySelector('.page-wrapper');
  function lock(on) { var s = (pw && pw.scrollHeight > pw.clientHeight + 1) ? pw : document.documentElement; s.style.overflow = on ? 'hidden' : ''; }

  function init(wrap) {
    var el = wrap.querySelector('.ug-cl[data-sid]');
    if (!el || wrap.dataset.ugReady) return;
    wrap.dataset.ugReady = '1';
    var sid = el.dataset.sid, busy = null;
    var root = function () { return document.getElementById('ug-cl-' + sid); };
    function sectionUrl(u) { var x = new URL(u, location.href); x.searchParams.set('section_id', sid); return x.toString(); }
    function cleanUrl(u) { var x = new URL(u, location.href); x.searchParams.delete('section_id'); x.searchParams.delete('page'); return x.pathname + x.search; }

    function load(u, push, keepDrawer) {
      var r = root(); if (!r) return; if (busy) busy.abort(); busy = new AbortController();
      var dw = r.querySelector('dialog[open]');
      var acc = dw ? [].map.call(dw.querySelectorAll('details'), function (d) { return d.open; }) : null;
      var dwTop = dw ? dw.querySelector('.ug-cl__dw-body').scrollTop : 0;
      r.classList.add('is-loading'); r.setAttribute('aria-busy', 'true');
      fetch(sectionUrl(u), { signal: busy.signal }).then(function (res) { return res.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), n = doc.getElementById('ug-cl-' + sid);
        if (!n) { location.href = u; return; }
        if (dw && dw.open) { dw.close(); lock(false); }
        r.replaceWith(n);
        if (push) history.pushState({ ugcl: 1 }, '', cleanUrl(u));
        if (keepDrawer && acc) {
          var d2 = n.querySelector('dialog');
          if (d2) { d2.showModal(); lock(true); d2.querySelectorAll('details').forEach(function (d, i) { if (acc[i] !== undefined) d.open = acc[i]; }); d2.querySelector('.ug-cl__dw-body').scrollTop = dwTop; }
        } else {
          var h = n.querySelector('.ug-cl__count'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
        }
        document.dispatchEvent(new CustomEvent('ug:listing:updated', { detail: { sid: sid } }));
      }).catch(function (e) { if (e.name !== 'AbortError') location.href = u; })
        .finally(function () { var r2 = root(); if (r2) { r2.classList.remove('is-loading'); r2.removeAttribute('aria-busy'); } });
    }

    wrap.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-ug-nav]');
      if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); load(a.href, true, !!a.closest('dialog')); return; }
      if (e.target.closest('[data-open-filters]')) { var d = root().querySelector('dialog'); if (d) { d.showModal(); lock(true); } return; }
      if (e.target.closest('[data-close-filters]')) { var d2 = e.target.closest('dialog'); if (d2) d2.close(); return; }
      if (e.target.matches && e.target.matches('dialog.ug-cl__drawer[open]')) {
        var b = e.target.getBoundingClientRect();
        if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) e.target.close();
        return;
      }
      var m = e.target.closest('a[data-more]');
      if (m) {
        e.preventDefault(); if (m.classList.contains('is-busy')) return;
        m.classList.add('is-busy'); m.setAttribute('aria-busy', 'true');
        fetch(sectionUrl(m.href)).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('#ug-cl-' + sid + ' [data-grid]'), f = doc.querySelector('#ug-cl-' + sid + ' [data-foot]');
          var grid = root().querySelector('[data-grid]'), first = null;
          if (g) [].slice.call(g.children).forEach(function (li) { var x = document.adoptNode(li); if (!first) first = x; grid.appendChild(x); });
          var foot = root().querySelector('[data-foot]'); if (f && foot) foot.replaceWith(document.adoptNode(f));
          if (first) { var l = first.querySelector('.ug-card__t a'); if (l) l.focus({ preventScroll: true }); }
        }).catch(function () { location.href = m.href; });
      }
    });
    wrap.addEventListener('close', function (e) { if (e.target.matches && e.target.matches('dialog.ug-cl__drawer')) lock(false); }, true);
    wrap.addEventListener('submit', function (e) {
      var f = e.target.closest('form[data-ug-form]'); if (!f) return; e.preventDefault();
      var fd = new FormData(f), q = new URLSearchParams(); fd.forEach(function (v, k) { if (v !== '') q.append(k, v); });
      load(f.action.split('?')[0] + '?' + q.toString(), true, !!f.closest('dialog'));
    });
    wrap.addEventListener('change', function (e) {
      if (!e.target.matches('[data-autosubmit]')) return;
      var f = e.target.form; if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
    wrap.addEventListener('toggle', function (e) {
      var d = e.target; if (d.matches && d.matches('details[data-dd]') && d.open) root().querySelectorAll('details[data-dd][open]').forEach(function (x) { if (x !== d) x.open = false; });
    }, true);
    document.addEventListener('pointerdown', function (e) { var r = root(); if (!r) return; r.querySelectorAll('details[data-dd][open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; }); });
    document.addEventListener('keydown', function (e) { if (e.key !== 'Escape') return; var r = root(); if (!r) return; r.querySelectorAll('details[data-dd][open]').forEach(function (d) { d.open = false; d.querySelector('summary').focus(); }); });
    window.addEventListener('popstate', function () { if (root()) load(location.href, false); });
  }

  function initAll() { document.querySelectorAll('.ug-cl[data-sid]').forEach(function (el) { var w = el.closest('.shopify-section'); if (w) init(w); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
